/** The words a risk's fixed fields are shown in — one home, because the register and the risk's own
 * page describe the same row and two spellings of one category is how a reader decides they are two
 * risks. */

/** The categories in a reader's words. The split is the TCFD-derived one, and it matters: "a
 * carbon price" and "a flood" have nothing in common operationally, so a register that lumped them
 * would make the response column meaningless. */
export const CATEGORY: Record<string, string> = {
  physical_acute: "Physical — an event",
  physical_chronic: "Physical — a long-term shift",
  policy: "Policy and regulation",
  market: "Market",
  technology: "Technology",
  reputation: "Reputation",
  legal: "Legal",
};

export const HORIZON: Record<string, string> = {
  short: "Short term",
  medium: "Medium term",
  long: "Long term",
};

/** The four standard responses, with what each commits you to. **There is no "monitor"**: watching
 * a risk is not a response to it, it is what you do while you accept one — which is what `accept`
 * plus a review trigger says precisely. */
export const STRATEGY: Record<string, string> = {
  avoid: "Avoid — stop doing the thing",
  reduce: "Reduce — lower the likelihood or the consequence",
  transfer: "Transfer — insure it or contract it out",
  accept: "Accept — live with it, and watch the trigger",
};
